import Game from "./components/Game";
import "./index.css";

function App() {
  return <Game />;
}

export default App;
